import { useEffect, useState } from "react";
import { loadModules } from "esri-loader";
import LoadingOverlay from "./LoadingOverlay/LoadingOverlay";

const URLServDivPol =
    process.env.REACT_APP_HERMES2_URL +
    process.env.REACT_APP_DIVISION_POLITICA_URL;

const SelectMpio = ({ selectedDepto, selectedMpio, setSelectedMpio }) => {
    const [mpios, setMpios] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedDepto === "-1") {
            setMpios([]);
            setSelectedMpio("-1");
            return;
        }

        setLoading(true);

        loadModules(["esri/tasks/query", "esri/tasks/QueryTask"]).then(
            ([Query, QueryTask]) => {
                const queryTask = new QueryTask(URLServDivPol + "6");
                const query = new Query();
                query.where = `codigodepartamento='${selectedDepto}'`;
                query.orderByFields = ["municipio"];
                query.returnGeometry = false;
                query.outFields = [
                    "codigodane",
                    "codigodepartamento",
                    "municipio",
                ];
                queryTask.execute(query).then((results) => {
                    const filtered = results.features
                        .map((f) => f.attributes)
                        .filter(
                            (m) =>
                                m.municipio !==
                                "NOMBRE_ENT	SAN ANDRES Y  PROVIDENCIA (Santa Isabel)"
                        );
                    setMpios(filtered);
                    setLoading(false);
                });
            }
        );
    }, [selectedDepto, setSelectedMpio, setMpios]);

    const handleChange = (e) => {
        setSelectedMpio(e.target.value);
    };

    return (
        <div className="col-12 col-md-5">
            {loading && <LoadingOverlay mensaje="Consultando municipios..." />}
            <h3 className="titles-form font-mpb">Municipio:</h3>
            <div className="caja">
                <select
                    id="mpios"
                    className="form-select"
                    value={selectedMpio}
                    onChange={handleChange}
                >
                    <option value="-1">Seleccione un Municipio</option>
                    {mpios.map((m) => (
                        <option key={m.codigodane} value={m.codigodane}>
                            {m.municipio}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default SelectMpio;
